// Arabisch (ar), kaartApp: zelfde vorm als kaartApp.nl.ts (golf 3-integratie). De stappen voor
// Google, Outlook en de iPhone noemen de knoppen zoals die apps ze in het Arabisch tonen.
export const appPlacesAr = {
    placeholder: 'اكتب مكانًا، مثل مسبح De Vliet',
    hintSearch: 'اكتب 3 أحرف على الأقل: تظهر لك اقتراحات من خرائط Google.',
    searching: 'جارٍ البحث...',
    suggestions: 'اقتراحات',
    noResults: 'لم يُعثر على شيء. يمكنك أيضًا كتابة المكان بنفسك.',
    attribution: 'اقتراحات من خرائط Google',
    chosen: 'المكان المختار',
    change: 'مكان آخر',
    remove: 'إزالة المكان',
    typedOnly: 'نص فقط (بدون مكان على الخريطة)',
    notConfigured: 'البحث عبر خرائط Google غير مفعّل بعد على هذا الخادم. اكتب المكان بنفسك.',
    unavailable: 'خرائط Google لا تجيب الآن. اكتب المكان بنفسك، أو حاول مرة أخرى بعد قليل.',
    tooMany: 'طلبات بحث كثيرة في وقت قصير. حاول مرة أخرى بعد {minutes} دقيقة.',
    saveFailed: 'لم يُحفظ المكان (لكن الموعد حُفظ). حاول مرة أخرى بعد قليل.',
    travelTitle: 'مدة الطريق',
    travelAuto: '{minutes} د {mode}',
    travelAutoHint: 'محسوبة من مكانكم. إذا اخترت مدة بنفسك في الأسفل، فهي التي تُعتمد.',
    travelPending: 'تُحسب عند الحفظ.',
    travelStatus: {
        no_origin: 'اختر أولًا مكان عائلتكم، ثم يحسب التطبيق مدة الطريق.',
        no_route: 'لا تعرف خرائط Google طريقًا إلى هذا المكان.',
        not_configured: 'حساب مدة الطريق غير مفعّل بعد على هذا الخادم.',
        unavailable: 'تعذّر حساب مدة الطريق الآن. سنحاول مرة أخرى عند الحفظ التالي.',
        module_off: 'مدة الطريق مطفأة (الإعدادات · الوحدات).',
    },
    modeTitle: 'كيف تذهبون؟',
    modeUsual: 'كالمعتاد',
    modes: { drive: 'السيارة', bicycle: 'الدراجة', walk: 'مشيًا' },
    modeWith: { drive: 'بالسيارة', bicycle: 'بالدراجة', walk: 'مشيًا' },
    autoOption: 'تلقائي ({minutes} د)',
    // fix/afspraakformulier: schakelaar bij "Waar" (onthouden op dit apparaat, per gebruiker).
    google: 'البحث عبر خرائط Google',
    googleOn: 'يعمل: اقتراحات عبر خادمنا (خرائط Google).',
    googleOff: 'متوقف: تكتب المكان بنفسك. لا يُرسل شيء إلى Google.',
    moduleOff: 'البحث عن الأماكن متوقف (الإعدادات · الوحدات). اكتب المكان فقط.',
};
export const appTravelAr = {
    title: 'مدة الطريق والأماكن',
    intro: 'اختر مكانًا من الاقتراحات في خانة «أين»، فيحسب التطبيق كم ستكونون في الطريق. ويقول لكم الجهاز اللوحي في الوقت المناسب إن عليكم الانطلاق.',
    modeTitle: 'هكذا نسافر عادةً',
    modeHint: 'يمكنك اختيار شيء آخر لكل موعد.',
    saved: 'تم الحفظ',
    originMissing: 'مكانكم ما زال ناقصًا. بدون نقطة انطلاق لا توجد مدة طريق.',
    originLink: 'اختيار المكان',
    googleOff: 'خرائط Google غير مفعّلة بعد على هذا الخادم: لا تعمل الاقتراحات ولا مدة الطريق. الكتابة في خانة «أين» تعمل دائمًا.',
    privacyTitle: 'ما الذي يُرسل إلى Google؟',
    privacyBody: 'فقط ما تكتبه في خانة «أين»، وموقع تقريبي حول مكان سكنكم (نحو 5 كم)، ولمدة الطريق نقطة الانطلاق بدقة كيلومتر تقريبًا. أبدًا لا أسماء ولا عناوين بريد إلكتروني ولا من يذهب معكم. Google يحسب لنا؛ والجهاز اللوحي ومتصفحك لا يتواصلان مع Google أبدًا.',
    settingsBody: 'السيارة أو الدراجة أو المشي؛ ما الذي يُرسل إلى Google',
};
export const appFeedsAr = {
    title: 'ربط التقويم',
    settingsBody: 'مواعيدكم أيضًا في Google أو Outlook أو على iPhone',
    intro: 'ضعوا مواعيدكم أيضًا في تقويم Google أو Outlook أو على iPhone. تبقى اللوحة هي مكان التخطيط: ما تغيّره هناك لا يعود إلى هنا.',
    oneWay: 'باتجاه واحد',
    inbound: 'والعكس، أي جلب تقويم المدرسة أو الرياضة؟ تفعل ذلك في التقاويم.',
    inboundLink: 'إلى التقاويم',
    forWho: 'لمن',
    lastFetchedNever: 'لم يحدث بعد',
    settingsLabel: 'إعدادات هذا الرابط',
    newTitle: 'رابط جديد',
    whose: 'أي مواعيد؟',
    whole: 'العائلة كلها',
    memberOnly: '{name} فقط',
    busyOnly: 'إظهار «مشغول» فقط',
    busyOnlyHint: 'يرى الآخرون أن هناك شيئًا، لا ما هو. مفيد لتقويم العمل.',
    faith: 'وأيضًا المواعيد المتعلقة بديننا (مثل الصلاة أو درس المسجد)',
    faithHint: 'مطفأ افتراضيًا: عندها تقرؤها Google أو Microsoft أو Apple أيضًا.',
    create: 'إنشاء رابط',
    creating: 'لحظة من فضلك...',
    created: 'رابطك جاهز',
    copy: 'نسخ الرابط',
    copied: 'تم النسخ',
    copyFailed: 'لم ينجح النسخ. حدّد الرابط وانسخه بنفسك.',
    openApple: 'فتح في التقويم (iPhone، Mac)',
    linkOnce: 'الصق الرابط الآن في تطبيق التقويم. لا نحتفظ به بشكل مقروء: لاحقًا تنشئ رابطًا جديدًا ببساطة.',
    linkLabel: 'رابطك',
    listTitle: 'روابطكم',
    empty: 'لا توجد روابط بعد. أنشئ واحدًا في الأعلى.',
    forWhole: 'العائلة كلها',
    forMember: '{name}',
    badgeBusy: 'مشغول فقط',
    badgeFaith: 'مع الدين',
    lastFetched: 'آخر جلب: {when}',
    neverFetched: 'لم يجلبه أي تطبيق تقويم بعد',
    hiddenLink: 'ترى الرابط نفسه فقط عند إنشائه.',
    renew: 'رابط جديد',
    renewTitle: 'إنشاء رابط جديد؟',
    renewBody: 'بعدها لن يعمل الرابط القديم. الصق الرابط الجديد مرة أخرى في تطبيق التقويم.',
    renewConfirm: 'إنشاء رابط جديد',
    revoke: 'سحب',
    revokeTitle: 'سحب الرابط؟',
    revokeBody: 'يتوقف هذا الرابط عن العمل فورًا. تختفي المواعيد من التقويم الآخر عند التحديث التالي.',
    revokeConfirm: 'سحب',
    revoked: 'سُحب الرابط',
    cancel: 'إلغاء',
    tooMany: '20 رابطًا على الأكثر لكل عائلة. اسحب رابطًا قديمًا أولًا.',
    howTitle: 'هكذا تضيفه',
    google: {
        title: 'تقويم Google',
        steps: [
            'افتح تقويم Google على حاسوب (calendar.google.com).',
            'انقر على علامة الزائد بجانب «تقاويم أخرى» على الجانب.',
            'اختر «من عنوان URL».',
            'الصق الرابط وانقر على «إضافة تقويم».',
        ],
    },
    outlook: {
        title: 'Outlook وMicrosoft 365',
        steps: [
            'افتح Outlook على الويب (outlook.office.com أو outlook.live.com).',
            'اذهب إلى التقويم واختر «إضافة تقويم».',
            'اختر «الاشتراك من الويب».',
            'الصق الرابط، وأعطِ التقويم اسمًا، وانقر على «استيراد».',
        ],
    },
    apple: {
        title: 'iPhone وiCloud',
        steps: [
            'افتح الإعدادات على iPhone.',
            'اضغط على التطبيقات، ثم التقويم، ثم حسابات التقويم، ثم «إضافة حساب». (على iPhone أقدم: التقويم، ثم الحسابات.)',
            'اضغط على «أخرى» ثم على «إضافة تقويم مشترك».',
            'الصق الرابط واضغط على «التالي» ثم «حفظ».',
        ],
    },
    refreshNote: 'بصراحة: تقويم Google يجلب مثل هذا الرابط مرة كل بضع ساعات فقط، وأحيانًا أقل. Outlook وiPhone يجلبانه أكثر. لذلك لا يظهر التغيير فورًا في كل مكان؛ أما على اللوحة فيظهر فورًا.',
    privacyNote: 'المواعيد الخاصة لا تُرسل أبدًا. من لديه الرابط يستطيع قراءة المواعيد: لا تشاركه مع غيرك، واسحبه إن كان متداولًا في مكان ما.',
    icsBusy: 'مشغول',
    /** Een bijzondere dag van meer dagen in de .ics. */
    icsDayOf: '{title} (اليوم {index} من {count})',
};
//# sourceMappingURL=kaartApp.ar.js.map